import React from "react"
import Sprite from "../../_Atoms/Sprites"

export const PrevButton = ({ enabled, onClick, inverted }) => (
  <button
    className={`embla__button embla__button--prev ${
      inverted ? "embla__button--inverted" : ""
    }`}
    aria-label="Previous slide"
    onClick={onClick}
    disabled={!enabled}
  >
    <Sprite name="arrow" />
  </button>
)

export const NextButton = ({ enabled, onClick, inverted }) => (
  <button
    className={`embla__button embla__button--next ${
      inverted ? "embla__button--inverted" : ""
    }`}
    aria-label="Next slide"
    onClick={onClick}
    disabled={!enabled}
  >
    <Sprite name="arrow" />
  </button>
)
